<header [disableMobileMenu]="true">
    <launcher-mobile mobileMenuSection></launcher-mobile>
    <span userActions class="loc" style="color:transparent">__</span>
    <help userActions [compactView]="false"></help>
</header>
<div class="container-fluid rs-container">
    <div class="row">
        <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;">
            <h1 style="font-size: 24px; text-align: center;">Página no encontrada</h1>
            <p style="margin-top: 50px; margin-bottom: 50px; text-align: center;">La página solicitada no existe.</p>
            <div style="display:flex; flex-direction:column; align-content:center;">
                <a style="text-align:center;" [href]="'/'">Volver</a>
            </div>
        </div>
    </div>
</div>
